import React from 'react';

/**
 * Format relative time (e.g., "2 hours ago", "3 days ago")
 */
const formatRelativeTime = (timestamp) => {
  if (!timestamp) return '';
  
  const now = Date.now();
  const diff = now - timestamp;
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) return `${days} day${days > 1 ? 's' : ''} ago`;
  if (hours > 0) return `${hours} hour${hours > 1 ? 's' : ''} ago`;
  if (minutes > 0) return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
  return 'Just now';
};

/**
 * Get session preview from first message
 */
const getSessionPreview = (session) => {
  if (session.preview) return session.preview;
  if (session.messages && session.messages.length > 0) {
    const firstMessage = session.messages[0];
    const text = firstMessage.content || firstMessage.text || '';
    return text.substring(0, 100) + (text.length > 100 ? '...' : '');
  }
  return '';
};

export default function MobileSessionsDrawer({
  isOpen,
  onClose,
  sessions = [],
  onOpenSession,
  onNewChat,
  title = 'Recent Sessions',
}) {
  if (!isOpen) return null;

  // Limit to 10 most recent sessions
  const limitedSessions = sessions.slice(0, 10);

  return (
    <div className="ov-mobile-sessions-overlay" role="dialog" aria-modal="true" aria-label="Session history">
      <div className="ov-mobile-sessions-sheet">
        <div className="ov-mobile-sessions-header">
          <div className="ov-mobile-sessions-title">{title}</div>
          <button type="button" className="ov-mobile-sessions-close" onClick={onClose} aria-label="Close sessions">
            ×
          </button>
        </div>

        {onNewChat && (
          <div style={{ padding: '12px 16px', borderBottom: '1px solid #e5e7eb', flexShrink: 0 }}>
            <button
              type="button"
              onClick={() => {
                onNewChat();
                onClose();
              }}
              style={{
                width: '100%',
                padding: '10px 16px',
                backgroundColor: '#3B82F6',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: '600',
                cursor: 'pointer',
              }}
            >
              + New Chat
            </button>
          </div>
        )}

        <div className="ov-mobile-sessions-list">
          {limitedSessions.length === 0 ? (
            <div className="ov-mobile-sessions-empty">No sessions yet. Start a conversation to begin.</div>
          ) : (
            limitedSessions.map((s) => (
              <button
                key={s.id}
                type="button"
                className="ov-mobile-session-item"
                onClick={() => onOpenSession(s)}
              >
                <div className="ov-mobile-session-row">
                  <div className="ov-mobile-session-name">{s.title || 'Session'}</div>
                  <div className="ov-mobile-session-time">
                    {formatRelativeTime(s.createdAt || s.updatedAt)}
                  </div>
                </div>
                <div className="ov-mobile-session-preview">{getSessionPreview(s)}</div>
              </button>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

